import {Navigate} from 'react-router-dom';
import {Center, Loader} from '@mantine/core';
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {useAuth} from '../../../hooks/useAuth';
import {rbacActions} from '../../../config/rbac/actions';
import {NoAccessPage} from './NoAccessPage';

// The public landing page. It renders no copy for a signed-out visitor until
// the app's own public content is decided (FNP-1662). The header and Sign in
// button come from PublicLayout.
//
// A signed-in person who may list people goes straight to the users list, the
// app's one module. Anyone else stays here and is told why. Never redirect
// them on: the users routes send a person without ListUsers back to "/", and
// the two redirects looped for every non-admin (FNP-2015).
export const HomePage = () => {
    const {status} = useAuth();
    const {authorizing, allowedActions} = useVerifiedPermissions();

    if (status !== 'authenticated') {
        return null;
    }

    if (authorizing) {
        return <Center p='xl'><Loader/></Center>;
    }

    return allowedActions.includes(rbacActions.ListUsers)
        ? <Navigate to='/users' replace/>
        : <NoAccessPage/>;
};
